import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedList from 'I18n/components/FormattedList';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import { getBrandVoiceUrl } from '../utils/urls';
import { MAGENTA } from 'ai-components-ui-library/styles/colors';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BREEZE_MAGENTA = MAGENTA['400'];

/**
 * @deprecated - please import BrandVoiceMessage from ui-brand-identity-lib instead
 */
const BrandVoiceText = ({
  brandVoiceLinkKey,
  brandVoiceOptions
}) => {
  const {
    brandKitId,
    voiceChannel,
    voiceData
  } = brandVoiceOptions || {};
  const {
    tone,
    personality
  } = voiceData || {};
  const hasBrandVoiceData = tone && tone.length && personality && personality.length;
  if (!hasBrandVoiceData) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: brandVoiceLinkKey,
      elements: {
        UILink
      },
      options: {
        href: getBrandVoiceUrl(brandKitId),
        external: true
      }
    });
  }
  const brandVoice = /*#__PURE__*/_jsx(UITooltip, {
    headingText: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        color: BREEZE_MAGENTA,
        name: "breezeSingleStar"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.header"
      })]
    }),
    title: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.voiceData_jsx",
        elements: {
          b: 'b',
          br: 'br'
        },
        options: {
          personality: /*#__PURE__*/_jsx(FormattedList, {
            twoWordsConnector: ", ",
            lastWordConnector: ", ",
            children: personality.map(personalityType => /*#__PURE__*/_jsx(FormattedMessage, {
              message: `baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.personalityTypes.${personalityType}`,
              options: {
                defaultValue: personalityType
              }
            }, personalityType))
          }),
          tone: /*#__PURE__*/_jsx(FormattedList, {
            twoWordsConnector: ", ",
            lastWordConnector: ", ",
            children: tone.map(toneType => /*#__PURE__*/_jsx(FormattedMessage, {
              message: `baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.toneTypes.${toneType}`,
              options: {
                defaultValue: toneType
              }
            }, toneType))
          })
        }
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "300",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.enabledForChannel.${voiceChannel || 'default'}`,
          options: {
            brandSettingsLink: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "baseContentGenerationModal.inlineToolbar.brandVoice.tooltip.brandSettingsLink_jsx",
              elements: {
                UILink
              },
              options: {
                external: true,
                // For some reason clicking on the link was not working with just href,
                // so gotta manually open it with onClick
                onClick: () => {
                  window.open(getBrandVoiceUrl(brandKitId), '_blank');
                }
              }
            })
          }
        })
      })]
    }),
    use: "longform",
    children: /*#__PURE__*/_jsx(UILink, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "baseContentGenerationModal.inlineToolbar.brandVoice.label"
      })
    })
  });
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "baseContentGenerationModal.inlineToolbar.brandVoice.usingBrandVoice",
    options: {
      brandVoice
    }
  });
};
export default BrandVoiceText;